import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 * */
export default class GetLiteralsI18nUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Repository} deps.repository
   * @param {Object} deps.log
   * */
  constructor({repository, log} = {}) {
    super({repository, log})

    this._repository = repository
    this._log = log
  }

  /**
   * @return {Promise<Object, Error>} list of suggestions
   * @property {Array<{literal: string, model:number}>} suggestions
   **/
  execute = () => this._repository.getLiterals().then(literals => literals.toJSON())
}
